'use client'

import { motion } from 'framer-motion'
import { PropsWithChildren } from 'react'

type TransitionProps = {
  direction?: 'horizontal' | 'vertical'
  className?: string
} & PropsWithChildren

export default function Transition({
  children,
  direction = 'vertical',
  className = '',
}: TransitionProps) {
  return (
    <motion.div
      initial={false}
      animate={{ opacity: 1, ...(direction === 'vertical' ? { y: 0 } : { x: 0 }) }}
      exit={{ opacity: 0, ...(direction === 'vertical' ? { y: 10 } : { x: 10 }) }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
